import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    constructor(private router: Router, private activatedRoute: ActivatedRoute, private titleService: Title) {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => {
                    let child = this.activatedRoute.firstChild;

                    while (child) {
                        if (child.firstChild) {
                            child = child.firstChild;
                        } else if (child.snapshot.data && child.snapshot.data['title']) {
                            return child.snapshot.data['title'];
                        } else {
                            return null;
                        }
                    }
                    return null;
                })
            )
            .subscribe((data: any) => {
                if (data) {
                    this.titleService.setTitle('MSIN - ' + data);
                } else {
                    this.titleService.setTitle('MSIN');
                }
            });
    }

    ngOnInit() {}
}
